var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 59,
    viewBox: "0 0 160 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.649 20.5403C149.46 20.27 150.271 20.8106 150.271 20.8106C150.812 21.3511 151.352 21.3511 151.893 20.8106C151.622 19.9998 150.812 19.7295 150.271 19.7295C149.46 19.9998 148.92 20.27 148.649 20.5403Z",
    fill: "url(#paint0_linear_14980_10782)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9717 7.83789C53.7825 9.45952 57.296 15.1352 63.5122 18.1082C71.6204 22.4325 81.8907 22.9731 89.188 25.4055C93.242 26.7568 97.2961 28.6487 100.539 31.3515C107.296 35.9461 116.485 48.3785 119.188 51.892C120.539 53.5137 122.161 55.1353 122.431 55.4056C124.053 56.7569 127.026 58.6488 131.35 58.3785C131.62 58.3785 131.891 58.3785 132.161 58.3785C129.188 58.6488 124.323 57.2975 120.539 51.3515C114.593 42.7028 109.188 35.9461 104.323 31.3515C99.4583 27.0271 95.1339 25.1352 91.6204 23.7839C84.5934 21.0812 75.4042 21.0812 66.4852 17.8379C63.5122 16.7568 61.0798 15.4055 59.1879 14.0541C55.6744 11.3514 54.0528 8.91897 52.9717 7.83789Z",
    fill: "url(#paint1_linear_14980_10782)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9717 7.83789C53.7825 9.45952 57.296 15.1352 63.5122 18.1082C71.6204 22.4325 81.8907 22.9731 89.188 25.4055C93.242 26.7568 97.2961 28.6487 100.539 31.3515C107.296 35.9461 116.485 48.3785 119.188 51.892C120.539 53.5137 122.161 55.1353 122.431 55.4056C124.053 56.7569 127.026 58.6488 131.35 58.3785C131.62 58.3785 131.891 58.3785 132.161 58.3785C129.188 58.6488 124.323 57.2975 120.539 51.3515C114.593 42.7028 109.188 35.9461 104.323 31.3515C99.4583 27.0271 95.1339 25.1352 91.6204 23.7839C84.5934 21.0812 75.4042 21.0812 66.4852 17.8379C63.5122 16.7568 61.0798 15.4055 59.1879 14.0541C55.6744 11.3514 54.0528 8.91897 52.9717 7.83789Z",
    fill: "url(#paint2_linear_14980_10782)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.513 2.43244C143.513 2.43244 151.622 5.40542 148.108 12.973C144.324 8.64867 143.513 4.32433 143.513 2.43244ZM50.8105 0C50.8105 0.270271 50.8105 0.270271 50.8105 0C50.8105 0 52.1619 2.43244 55.1349 5.67569C58.6484 9.45948 64.3241 12.973 71.0809 13.7838C74.3241 14.3244 78.6484 14.0541 82.4322 13.5135C88.9187 12.4325 91.8917 10.5406 98.108 9.72975C102.703 9.18921 106.757 9.45948 110.54 10.8108C115.135 12.1622 118.919 14.8649 122.703 17.0271C126.757 19.4595 131.081 21.3514 135.135 21.6217C138.378 21.8919 141.081 21.3514 143.243 20.5406C147.027 18.6487 148.378 15.946 148.378 15.946C148.378 15.946 151.351 18.919 155.405 21.0811C156.486 21.6217 157.297 22.1622 158.378 22.4325C158.378 22.4325 158.108 25.1352 157.027 26.2163C157.297 26.4865 157.297 26.4865 157.297 26.4865C159.189 24.8649 160 22.1622 160 21.0811C159.189 20.8109 153.513 18.6487 149.189 14.3244C149.189 14.3244 151.081 10.5406 149.459 7.02704C147.838 3.51352 144.324 2.43244 143.513 2.43244H143.243C142.162 6.4865 144.324 11.6216 147.297 14.5946C145.135 17.5676 141.892 19.7298 136.757 19.4595C131.892 19.1892 127.297 16.7568 122.162 13.7838C116.757 10.5406 111.621 7.02704 102.162 7.02704C99.9998 7.02704 95.9458 7.29731 91.0809 8.64867C86.7566 10 80.5403 12.4325 72.1619 12.1622C68.1079 11.8919 63.7835 10.8108 60.27 8.3784C56.216 5.94596 52.9727 2.43244 50.8105 0C51.0808 0 51.0808 0 50.8105 0Z",
    fill: "url(#paint3_linear_14980_10782)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.513 2.43244C143.513 2.43244 151.622 5.40542 148.108 12.973C144.324 8.64867 143.513 4.32433 143.513 2.43244ZM50.8105 0C50.8105 0.270271 50.8105 0.270271 50.8105 0C50.8105 0 52.1619 2.43244 55.1349 5.67569C58.6484 9.45948 64.3241 12.973 71.0809 13.7838C74.3241 14.3244 78.6484 14.0541 82.4322 13.5135C88.9187 12.4325 91.8917 10.5406 98.108 9.72975C102.703 9.18921 106.757 9.45948 110.54 10.8108C115.135 12.1622 118.919 14.8649 122.703 17.0271C126.757 19.4595 131.081 21.3514 135.135 21.6217C138.378 21.8919 141.081 21.3514 143.243 20.5406C147.027 18.6487 148.378 15.946 148.378 15.946C148.378 15.946 151.351 18.919 155.405 21.0811C156.486 21.6217 157.297 22.1622 158.378 22.4325C158.378 22.4325 158.108 25.1352 157.027 26.2163C157.297 26.4865 157.297 26.4865 157.297 26.4865C159.189 24.8649 160 22.1622 160 21.0811C159.189 20.8109 153.513 18.6487 149.189 14.3244C149.189 14.3244 151.081 10.5406 149.459 7.02704C147.838 3.51352 144.324 2.43244 143.513 2.43244H143.243C142.162 6.4865 144.324 11.6216 147.297 14.5946C145.135 17.5676 141.892 19.7298 136.757 19.4595C131.892 19.1892 127.297 16.7568 122.162 13.7838C116.757 10.5406 111.621 7.02704 102.162 7.02704C99.9998 7.02704 95.9458 7.29731 91.0809 8.64867C86.7566 10 80.5403 12.4325 72.1619 12.1622C68.1079 11.8919 63.7835 10.8108 60.27 8.3784C56.216 5.94596 52.9727 2.43244 50.8105 0C51.0808 0 51.0808 0 50.8105 0Z",
    fill: "url(#paint4_linear_14980_10782)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.028 25.6756C157.028 25.6756 153.785 24.3242 149.731 24.3242C148.65 24.3242 147.299 24.3242 146.218 24.8648C144.596 25.4053 142.434 26.2161 141.083 27.5675C139.278 28.9559 137.33 31.2715 135.496 33.4517C133.76 35.5157 132.127 37.4583 130.812 38.3783C129.191 39.4594 127.028 40.5405 125.407 40.5405C130.542 41.3513 134.055 38.108 137.028 34.5945C139.731 31.3513 142.974 27.8377 145.407 26.7566C146.647 26.0125 148.115 25.7237 149.393 25.4722C149.507 25.4497 149.62 25.4275 149.731 25.4053C153.785 24.8648 157.299 25.9458 157.299 25.9458L157.028 25.6756Z",
    fill: "url(#paint5_linear_14980_10782)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.594 53.5135C127.567 56.4864 131.081 57.8378 134.324 57.5675C133.919 57.7027 133.581 57.8378 133.243 57.9729C132.905 58.1081 132.567 58.2432 132.162 58.3783C128.919 58.3783 124.054 57.027 120.54 51.3513C120.54 51.3513 117.027 45.9459 120.27 39.9999C122.973 34.8648 127.297 33.7837 129.73 33.7837C131.081 33.7837 132.162 34.054 132.162 34.054C126.216 33.7837 123.243 38.108 123.243 38.108C121.892 40.2702 120.54 42.9729 120.811 45.6756C121.081 47.5675 121.621 50.5405 124.594 53.5135Z",
    fill: "url(#paint6_linear_14980_10782)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1351 40H54.3243C52.973 40 51.8919 41.0811 51.8919 42.4324V52.4325C51.8919 52.4325 51.8919 53.5135 51.3513 54.0541C51.0811 54.3244 50.5405 54.5946 49.7297 54.5946H46.4865C45.6757 54.5946 45.1351 54.3244 44.8649 54.0541C44.3243 53.5135 44.3243 52.7027 44.3243 52.4325V42.4324C44.3243 41.0811 43.2432 40 41.8919 40H41.0811V52.4325C41.0811 52.973 41.0811 54.8649 42.7027 56.4865C43.5135 57.2973 44.5946 58.1081 46.7567 58.1081H50C52.1622 58.1081 53.5135 57.2973 54.0541 56.4865C55.6757 54.8649 55.6757 52.4325 55.6757 52.4325V40H55.1351Z",
    fill: "#FCFCFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8652 57.8379H75.9463C77.2977 57.8379 78.3788 56.4865 78.3788 55.4054V43.5135H83.7842C84.595 43.5135 85.1355 43.7838 85.4058 44.0541C85.6761 44.3243 85.9463 44.8649 85.9463 45.6757V47.2973C85.9463 48.1081 85.6761 48.6487 85.4058 48.9189C84.8653 49.4595 84.0544 49.4595 83.7842 49.4595H79.7301C80.5409 50.8108 82.4328 53.2433 83.7842 55.4054C85.4058 57.8379 86.7572 58.1081 88.1085 58.1081H90.0004L85.9463 51.8919H86.4869C87.2977 51.6216 87.8382 51.3514 88.1085 51.0811C89.1896 50.2703 89.7301 48.9189 89.7301 47.2973V45.6757C89.7301 43.5135 88.9193 42.1622 88.1085 41.6216C86.4869 40.2703 84.595 40 84.0544 40H75.1355V57.8379H74.8652Z",
    fill: "#FCFCFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9463 57.8376H57.8382C59.7301 57.8376 60.0004 57.0268 60.2706 56.216C60.5409 55.4052 64.3247 43.5133 64.3247 43.5133C64.3247 43.5133 68.1085 55.4052 68.3788 56.216C68.649 57.2971 69.1896 57.8376 70.8112 57.8376H72.7031L66.4869 39.7295H63.7841C62.1625 39.7295 61.3517 41.6214 61.0814 42.4322L55.9463 57.8376Z",
    fill: "#FCFCFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9449 43.5135H100.269C100.269 43.5135 101.35 43.5135 101.891 44.0541C102.161 44.3243 102.431 44.8649 102.431 45.6757V52.4325C102.431 53.2433 102.161 53.7838 101.891 54.0541C101.35 54.5946 100.54 54.5946 100.269 54.5946H95.9449V43.5135ZM105.675 52.4325V45.6757C105.675 43.5135 104.864 42.1622 104.053 41.6216C102.702 40.2703 100.54 40 99.999 40H92.1611V55.6757C92.1611 56.7568 92.9719 57.8379 94.3233 58.1081H99.999C99.999 58.1081 99.999 58.1081 100.269 58.1081C101.08 58.1081 102.702 57.8379 104.323 56.4865C104.864 55.6757 105.675 54.5946 105.675 52.4325Z",
    fill: "#FCFCFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 50.8113H20.5416V48.6491H19.1902C17.8389 48.3788 16.7578 49.4599 16.7578 50.8113Z",
    fill: "#FCFCFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0271 40H15.1352C13.2433 40 12.973 40.8108 12.7027 41.6216C12.4325 42.4325 8.64867 54.3244 8.64867 54.3244C8.64867 54.3244 4.86488 42.4325 4.5946 41.6216C4.32433 40.5406 3.78379 40 2.16217 40H0L5.13515 55.4055C5.40542 56.2163 6.21623 58.1082 7.83785 58.1082H10.5406L17.0271 40Z",
    fill: "url(#paint7_linear_14980_10782)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9466 57.8376H57.8385C59.7304 57.8376 60.0006 57.0268 60.2709 56.216C60.5412 55.4052 64.325 43.5133 64.325 43.5133C64.325 43.5133 68.1088 55.4052 68.379 56.216C68.6493 57.2971 69.1898 57.8376 70.8115 57.8376H72.7034L66.4872 39.7295H63.7844C62.1628 39.7295 61.352 41.6214 61.0817 42.4322L55.9466 57.8376Z",
    fill: "url(#paint8_linear_14980_10782)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4606 58.1082C28.92 58.1082 27.0281 57.8379 25.6768 56.4865C24.866 55.946 24.0552 54.5946 24.0552 52.4325V45.6757C24.0552 43.5135 24.866 42.4325 25.6768 41.6216C27.2984 40 29.1903 40 29.7308 40H35.1363C36.7579 40 37.839 41.0811 37.839 42.4325V43.2433H29.7308C29.4606 43.2433 28.6498 43.2433 28.1092 43.7838C27.8389 44.0541 27.5687 44.5946 27.5687 45.4054V52.1622C27.5687 52.973 27.8389 53.5136 28.1092 53.7838C28.6498 54.3244 29.4606 54.3244 29.7308 54.3244H34.3254V50.5406H30.8119V50.0001C30.8119 48.6487 32.1633 47.5676 33.5146 47.5676H37.5687V55.6757C37.5687 57.0271 36.2173 58.1082 34.866 58.1082H29.4606Z",
    fill: "url(#paint9_linear_14980_10782)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.325 40H55.6763V52.4325C55.6763 52.4325 55.6763 54.8649 54.0547 56.4865C53.5141 57.2974 52.1628 58.1082 50.0006 58.1082H46.7574C44.5952 58.1082 43.5141 57.2974 42.7033 56.4865C41.0817 54.8649 41.0817 52.973 41.0817 52.4325V40H41.8925C43.2439 40 44.3249 41.0811 44.3249 42.4325V52.4325C44.3249 52.7028 44.3249 53.5136 44.8655 54.0541C45.1358 54.3244 45.6763 54.5946 46.4871 54.5946H49.7304C50.5412 54.5946 51.0817 54.3244 51.352 54.0541C51.8925 53.5136 51.8925 52.4325 51.8925 52.4325V42.4325C51.8925 41.0811 52.9736 40 54.325 40Z",
    fill: "url(#paint10_linear_14980_10782)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9466 57.8379H75.1358V40H84.0547C84.5953 40 86.4872 40.2703 88.1088 41.6216C88.9196 42.1622 89.7304 43.5135 89.7304 45.6757V47.2973C89.7304 48.919 89.1899 50.2703 88.1088 51.0811C87.8385 51.3514 87.298 51.6217 86.4872 51.8919H85.9466L90.0007 58.1082H88.1088C86.7575 58.1082 85.4061 57.8379 83.7845 55.4055C83.073 54.2672 82.2118 53.054 81.4373 51.963C80.7408 50.9819 80.1143 50.0994 79.7304 49.4595H83.7845C84.0547 49.4595 84.8656 49.4595 85.4061 48.919C85.6764 48.6487 85.9466 48.1082 85.9466 47.2973V45.6757C85.9466 44.8649 85.6764 44.3244 85.4061 44.0541C85.1358 43.7838 84.5953 43.5135 83.7845 43.5135H78.3791V55.4055C78.3791 56.4866 77.298 57.8379 75.9466 57.8379Z",
    fill: "url(#paint11_linear_14980_10782)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.675 45.6757V52.4325C105.675 54.477 104.95 55.5549 104.414 56.3517L104.323 56.4865C102.702 57.8379 101.08 58.1082 100.269 58.1082H94.3234C92.9721 57.8379 92.1613 56.7568 92.1613 55.6757V40H99.9991C100.54 40 102.702 40.2703 104.053 41.6216C104.864 42.1622 105.675 43.5135 105.675 45.6757ZM100.269 43.5135H95.9451V54.5946H100.269C100.54 54.5946 101.35 54.5947 101.891 54.0541C102.161 53.7838 102.432 53.2433 102.432 52.4325V45.6757C102.432 44.8649 102.161 44.3244 101.891 44.0541C101.35 43.5135 100.269 43.5135 100.269 43.5135Z",
    fill: "url(#paint12_linear_14980_10782)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7573 50.8108H20.5411V48.6487H19.1898C17.8384 48.3784 16.7573 49.4595 16.7573 50.8108Z",
    fill: "url(#paint13_linear_14980_10782)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1352 40H17.0271L10.5406 58.1082H7.83785C6.21623 58.1082 5.40542 56.2163 5.13515 55.4055L0 40H2.16217C3.78379 40 4.32433 40.5406 4.5946 41.6216C4.86488 42.4325 8.64867 54.3244 8.64867 54.3244C8.64867 54.3244 12.4325 42.4325 12.7027 41.6216C12.973 40.8108 13.2433 40 15.1352 40Z",
    fill: "url(#paint14_linear_14980_10782)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14980_10782",
    x1: 150.271,
    y1: 19.7295,
    x2: 150.271,
    y2: 21.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14980_10782",
    x1: 92.5664,
    y1: 7.83789,
    x2: 92.5664,
    y2: 58.4108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14980_10782",
    x1: 92.5664,
    y1: 7.83789,
    x2: 92.5664,
    y2: 58.4108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14980_10782",
    x1: 105.405,
    y1: 0,
    x2: 105.405,
    y2: 26.4865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14980_10782",
    x1: 105.405,
    y1: 0,
    x2: 105.405,
    y2: 26.4865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14980_10782",
    x1: 138.097,
    y1: 24.3242,
    x2: 138.097,
    y2: 58.3783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14980_10782",
    x1: 138.097,
    y1: 24.3242,
    x2: 138.097,
    y2: 58.3783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14980_10782",
    x1: 52.8374,
    y1: 39.7295,
    x2: 39.4585,
    y2: 58.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14980_10782",
    x1: 52.8374,
    y1: 39.7295,
    x2: 39.4585,
    y2: 58.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14980_10782",
    x1: 52.8374,
    y1: 39.7295,
    x2: 39.4585,
    y2: 58.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14980_10782",
    x1: 52.8374,
    y1: 39.7295,
    x2: 39.4585,
    y2: 58.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14980_10782",
    x1: 52.8374,
    y1: 39.7295,
    x2: 39.4585,
    y2: 58.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14980_10782",
    x1: 52.8374,
    y1: 39.7295,
    x2: 39.4585,
    y2: 58.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14980_10782",
    x1: 52.8374,
    y1: 39.7295,
    x2: 39.4585,
    y2: 58.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14980_10782",
    x1: 52.8374,
    y1: 39.7295,
    x2: 39.4585,
    y2: 58.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9D25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVgLogo);
export default __webpack_public_path__ + "static/media/VG-logo.208442525650356973477c9ab8210a11.svg";
export { ForwardRef as ReactComponent };